import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CanteensApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/canteens'
    }
}

export default new CanteensApiClient()
